import React from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';

// Renders trusted catalog Markdown (e.g. integration setup_instructions) as
// on-brand HTML. react-markdown does NOT render raw HTML by default, so this is
// safe. Element styling is mapped to tailwind so it matches the site's design
// system rather than relying on a `prose` plugin.
const COMPONENTS: Components = {
  p: ({
    children
  }) => <p className="text-[#475569] leading-relaxed mb-3 last:mb-0" data-id="element-4255" data-mp="25xuivz41dnel">{children}</p>,
  h2: ({
    children
  }) => <h3 className="text-lg font-bold text-[#333333] mt-5 mb-2 first:mt-0" data-id="element-4256" data-mp="2awoy6r2sotty">
      {children}
    </h3>,
  h3: ({
    children
  }) => <h4 className="text-base font-bold text-[#333333] mt-4 mb-2 first:mt-0" data-id="element-4257" data-mp="2ftp7dauxycpa">
      {children}
    </h4>,
  h4: ({
    children
  }) => <h5 className="text-sm font-bold text-[#333333] mt-3 mb-1 first:mt-0" data-id="element-4258" data-mp="3rafgb1qr1iml">
      {children}
    </h5>,
  ul: ({
    children
  }) => <ul className="list-disc pl-5 space-y-1.5 mb-3 text-[#475569]" data-id="element-4259" data-mp="3vaz9xvc4643z">{children}</ul>,
  ol: ({
    children
  }) => <ol className="list-decimal pl-5 space-y-1.5 mb-3 text-[#475569]" data-id="element-4260" data-mp="2n349k4adwvh2">
      {children}
    </ol>,
  li: ({
    children
  }) => <li className="leading-relaxed" data-id="element-4261" data-mp="2i5vre3p8krft">{children}</li>,
  a: ({
    href,
    children
  }) => <a href={href} target="_blank" rel="noopener noreferrer" className="text-[#EA580C] font-medium hover:underline break-words" data-id="element-4262" data-mp="2d4esgdqbbf1v">
      {children}
    </a>,
  code: ({
    children
  }) => <code className="font-mono text-[13px] bg-[#FFEDD5] text-[#C2410C] px-1.5 py-0.5 rounded break-words" data-id="element-4263" data-mp="246cvc99p96jv">
      {children}
    </code>,
  pre: ({
    children
  }) => <pre className="bg-[#2B211A] text-neutral-100 rounded-xl p-4 overflow-x-auto text-sm mb-3" data-id="element-4264" data-mp="1uf8j3hberzsq">
      {children}
    </pre>,
  strong: ({
    children
  }) => <strong className="font-bold text-[#333333]" data-id="element-4265" data-mp="1pi00xgq9fvrh">{children}</strong>,
  em: ({
    children
  }) => <em className="italic" data-id="element-4266" data-mp="1leaccr9l5e6g">{children}</em>
};
export function Markdown({
  children
}: {
  children: string;
}) {
  return <ReactMarkdown components={COMPONENTS} data-id="element-4267" data-mp="1ghtpe0e4h5uy">{children}</ReactMarkdown>;
}